import DocumentDetailsRow, {
	IDocumentDetailsItem
} from '../../../../common/components/documentViewer/documentDetailsRow';
import { toKebabCase } from '../../../../common/utils/stringUtils';
import { IOrderDetailsViewModel } from '../../typing/orderViewerViewModel';
import { IOrderViewerMainStore } from '../../typing/stores';
import PrintReceiptButton from '../orderViewerActions/printReceipt';
import { createStyles, makeStyles } from '@mui/styles';
import { inject, observer } from 'mobx-react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			paddingTop: '0.75rem',
			flexDirection: 'column',
			alignItems: 'flex-end',
			gap: '0.25rem',
			alignSelf: 'stretch'
		},
		terms: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-end',
			gap: '0.25rem',
			alignSelf: 'stretch'
		},
		rowRoot: {
			display: 'flex'
		},
		rowItem: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'flex-start',
			gap: '0.25rem'
		}
	})
);

export interface IOrderPriceProps {
	orderDetails?: IOrderDetailsViewModel;
}

const OrderPrice: React.FunctionComponent<IOrderPriceProps> = props => {
	const classes = useStyles();

	let rowKey = 0;
	const createRow = (title?: string, value?: string) => {
		if (value) {
			const item: IDocumentDetailsItem = {
				title: title,
				value: value,
				testId: toKebabCase(title)
			};
			return (
				<DocumentDetailsRow
					key={rowKey++}
					items={item}
					rowRootClass={classes.rowRoot}
					rowItemClass={classes.rowItem}
				/>
			);
		}

		return <></>;
	};

	return (
		<div className={classes.root}>
			<div className={classes.terms}>
				{createRow(localize('Subtotal'), props.orderDetails.subtotal)}
				{createRow('-', props.orderDetails.clientCost)}
				{createRow(`+ ${localize('Tax')}`, props.orderDetails.tax)}
				{createRow(localize('Total price'), props.orderDetails.total)}
				<PrintReceiptButton isPrimary={true} useText={true} useSmall={true} />
			</div>
		</div>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	orderDetails: stores.orderViewerStore.viewModel.orderDetails
}))(observer(OrderPrice));
